"use strict";

var end = {};

module.exports.PatentResource = {
  organisationseinheit: end,
  anmelderExtern: end,
  anmelderIntern: end,
  haupterfinder: end,
  ansprechpartner: end,
  land: end
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/resource/patent.js
// module id = x9iD
// module chunks = 0